<script>
import { SalesAPI } from '@/sales/api';
import { orderStatusColorVariant } from '@/sales/filters/statuses';
import EggOrderQuantityTable from '@/sales/components/EggOrderQuantityTable.vue';

export default {
  components: {
    EggOrderQuantityTable,
  },

  filters: {
    orderStatusColorVariant,
  },

  props: {
    order: { type: Object, required: true },
  },

  data: () => ({
    showOfficeItems: false,
  }),

  computed: {
    nonZeroOfficeItemCount() { return this.order.items.filter(x => x.office_quantity > 0).length },

    isDraft() { return this.order.status === 'draft' },
    isDone() { return this.order.status === 'done' },
    showFinalizeButton() { return this.isDraft },
    showPackedQuantities() { return this.isDone },
  },

  methods: {
    async onClickEditDriverQuantity(item) {
      if (!this.isDraft) {
        alert('Only Draft Orders can be edited');
        return;
      }

      let newValue = prompt(`New Driver Quantity for ${item.type.display_name}`, item.driver_quantity);
      if (newValue === null) return;

      let quantities = this.order.items.map(x => ({ item_id: x.id, driver: x.id === item.id ? newValue : x.driver_quantity, office: x.office_quantity }))
      let updatedOrder = await SalesAPI.saveEggOrder(this.order.id, quantities);
      this.$emit('saved', updatedOrder);
    },
    async onClickEditOfficeQuantity(item) {
      if (!this.isDraft) {
        alert('Only Draft Orders can be edited');
        return;
      }

      let newValue = prompt(`New Office Quantity for ${item.type.display_name}`, item.office_quantity);
      if (newValue === null) return;

      let quantities = this.order.items.map(x => ({ item_id: x.id, driver: x.driver_quantity, office: x.id === item.id ? newValue : x.office_quantity }))
      let updatedOrder = await SalesAPI.saveEggOrder(this.order.id, quantities);
      this.$emit('saved', updatedOrder);
    },

    onOrderFinalized() {
      this.$router.push({ name: 'sales/egg-orders' })
    },
  },
}
</script>

<template>
  <div>
    <b-card no-body>
      <h4 class="text-center my-2"> Order for {{order.date | formatDate('ddd YYYY-MM-DD')}} </h4>

      <b-badge :variant="order.status | orderStatusColorVariant" class="text-uppercase mx-auto mb-3"> {{order.status}} </b-badge>
    </b-card>

    <b-card class="mt-3">
      <egg-order-quantity-table
        heading="Driver"
        :items="order.items"
        :quantity-from-item-func="item => item.driver_quantity"
        :packed-quantity-from-item-func="item => item.driver_packed_quantity"
        :quantities-editable="isDraft"
        :show-packed="showPackedQuantities"
        @edit-item-quantity="onClickEditDriverQuantity"
        class="table table-bordered table-sm table-striped" />
    </b-card>

    <b-card class="mt-3">
      <div class="text-center">
        <b-form-checkbox v-model="showOfficeItems"> Show {{nonZeroOfficeItemCount}} office items </b-form-checkbox>
      </div>

      <transition name="fade" mode="out-in">
        <egg-order-quantity-table
          v-if="showOfficeItems"
          heading="Office"
          :items="order.items"
          :quantity-from-item-func="item => item.office_quantity"
          :packed-quantity-from-item-func="item => item.office_packed_quantity"
          :quantities-editable="isDraft"
          :show-packed="showPackedQuantities"
          @edit-item-quantity="onClickEditOfficeQuantity"
          class="table table-bordered table-sm table-striped mt-3" />
      </transition>

    </b-card>

    <b-card v-if="showFinalizeButton" class="mt-3">
      <div class="d-flex">
        <div class="mx-auto">
          <confirm-click>
            <api-button
              method="put"
              :url="`v1/sales/egg-orders/${encodeURIComponent(order.id)}/finalize`"
              :payload="{}"
              class="btn btn-primary"
              @executed="onOrderFinalized">
              <i class="fa fa-database"></i> Finalize Order
            </api-button>
          </confirm-click>
        </div>
      </div>
    </b-card>

  </div>
</template>

<style scoped>
td.clickable:hover {
  background-color: #b0b8c0;
}
</style>



// WEBPACK FOOTER //
// src/sales/components/EggOrder.vue